import { render, staticRenderFns } from "./CeisaBarangImporHeader.vue?vue&type=template&id=b1c731a2&"
import script from "./CeisaBarangImporHeader.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports